module.exports = __webpack_public_path__ + "static/media/91.24c6ab83.png";